import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import PfIcon from './assets/icons/PfIcon';
import { Link } from 'react-router-dom';

function About() {
    return (
        <Container className='container'>
            <Box className='bgimg3alt'>
                <Box className='contentW'>
                    <h1 style={{ fontFamily: 'var(--pf-font)', color: 'var(--pf-accent)', marginTop: 0, marginBottom: '1rem', fontSize: '1.8rem', letterSpacing: '0.04em' }}>
                        About Push Forward <PfIcon />
                    </h1>

                    <p>
                        Based out of Montreal, Quebec, Canada, the Push Forward sound was born out of spontaneous jam sessions that took place before, after and in between practice sessions for another project.
                    </p>

                    <p>
                        From early on in 2018, the group had been rehearsing for a live performance that was to feature tracks from{' '}
                        <a href='https://www.youtube.com/watch?v=q2S8N1gtUwo' rel='noreferrer' target='_blank' className='linkPop'>
                            People Arena's Life is the Ticket to Your Funeral
                        </a>. A show had been planned for May 8th 2020, but ultimately ended up being cancelled due to the covid-19 pandemic.
                    </p>

                    <p>
                        The group, at the time, was being led by People Arena creator,{' '}
                        <Link to='/about-people-arena' className='linkPop'>Andrew Wieczorek</Link>. While the song ideas and preprod tracks had long since been recorded by Andrew himself over 10 years prior, it was only in 2017 that longtime friend and drummer,{' '}
                        <Link to='/about-rim-bam-bito' className='linkPop'>Rim "Bam" Bito</Link> got to hear them for the first time. Rim immediately took a very strong liking to the powerfully emotional material and could not understand why the whole album had seemingly been shelved.
                    </p>

                    <p>
                        Bassist{' '}
                        <Link to='/about-yann-fingers-bonato' className='linkPop'>Yann "Fingers" Bonato</Link> and guitarist Degenotron were on board to bring the music to a live audience, gracing the music with their special blend of sonic soundscapes they had already perfected in their time playing together in{' '}
                        <a href='https://senzafine.bandcamp.com/album/lost-apes' rel='noreferrer' target='_blank' className='linkPop'>Senzafine</a>.
                    </p>

                    <p>
                        Rehearsing at a private jam space, the group was able to have basic recording gear permanently set up, so they could capture each practice session, with the intention of reviewing them later, with a 3rd-person perspective. As the 'tape' was nearly always rolling, even the unrehearsed jam sessions that eventually became a quite regular part of any rehearsal were saved along with the rest — sometimes a good way to warm up, or something that came from noodling at the end of any of the People Arena songs.
                    </p>

                    <p>
                        Once it had become evident that the{' '}
                        <Link to='/people-arena-petit-campus-poster' className='linkPop'>May 2020 show</Link> would be cancelled, the group decided to Push Forward with the groove and vibe that would come through the People Arena jams — the collective musicianship and brotherhood that came with weekly rehearsals over the course of 2 years. With the bank of idea-rich jams in hand, the group set out to refine the raw material and transform them into a record.
                    </p>

                    <p>
                        The resulting body of work was{' '}
                        <Link to='/music' className='linkPop'>Poussé</Link>, the band's independently produced debut album, available now.
                    </p>

                    <p>
                        The band has performed their original music at a number of intimate venues in Montreal, and continues to work on new music set to be released in the near future.
                    </p>
                </Box>
            </Box>
        </Container>
    );
}

export default About;
